import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Divider,
  Form,
  message,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Skeleton,
  Tag,
} from 'antd';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { debounce, get } from 'lodash';
import { ColumnsType, ColumnProps } from 'antd/es/table';
import ModalForm, { ImodalFormRef } from '@/components/ModalForm';
import EditCellTable, { IcustomColumnType } from '@/components/EditCellTable';
import { IFieldItem } from '@/components/CustomForm';
import CardPurchase, { IcardPurchaseRef } from '@/components/CardPurchase';
import CardRecharge, { IcardRechargeRef } from '@/components/CardRecharge';
import showGamePromptModal from '@/components/Reservation/GamePromptModal';
import PhoneCheckModal, { PhoneCheckModalRef } from '@/components/PhoneCheckModal';
import AdditionalRecordMobile, {
  IadditionalRecordMobileRef,
} from '@/pages/order/component/AdditionalRecordMobile';
import GuestDetailDrawer, { IGuestDetailRef } from '@/pages/guest/component/GuestDetailDrawer';
import MemberCancelCheckButton from '@/pages/guest/component/MemberCancelCheckButton';
import FixStickyTable from '@/components/FixStickyTable';
import BaseMobileInput from '@/components/BaseMobileInput';
import {
  formatAreaMobileStr,
  parseAreaMobileStr,
  validateMobileValue,
} from '@/components/BaseMobileInput/helper';
import BaseEmailInput, { EMAIL_REG } from '@/components/BaseEmailInput';
import IntlContext from '@/components/Intl/IntlContext';
import { fetchCustomerInfo, fetchSaveNewMasterMobile } from '@/api/guest';
import {
  clearData,
  getOrderCustomerInfo,
  getOrderDetailBaseInfo,
  orderAddMember,
  orderMemberCheckOut,
  orderUpdateBooker,
  orderUpdateMember,
  queryIsChangeMaster,
  saveData,
} from '@/redux/actions/order';
import { updateIdValidatedRes, getBusinessPaymentType } from '@/redux/actions/guest';
import { IcustomerInfo, IroomInfo } from '@/redux/reducers/order';
import { filterFormParams, renderIntlLabel } from '@/utils';
import { HistoryParams } from '@/utils/type';
import Card from '@/utils/card';
import {
  MainOrderStatus,
  MemberType,
  MEMBER_TYPE_MAP,
  PriceChannel,
  SubOrderStatus,
  ContractType,
  CertIDType,
} from '@/config';
import { parseFen2Currency } from '@/utils/number';
import { fetchBecomeMasterV2, fetchCurrentCheckinStatus } from '@/api/order';
import { transformCardInfo } from '@/utils/transform';
import { trackIDCardReader, IDCardReaderScene } from '@/utils/monitor';
import { TenantGlobalConfig } from '@/components/Intl/IntlContext/helper';

import RoomTypeScroll from '../RoomTypeScroll';
import CardInfoModal, { CardInfo, ImodalRef } from './CardInfoModal';
import style from './index.module.scss';

let cardInstance = null;

const Guest: React.FC<any> = ({
  currentShop,
  businessList,
  sourceChannelType,
  orderBaseInfo,
  reserveDetail,
  checkInDetail,
  reserveCustomerList,
  checkInCustomerList,
  checkInRoomInfoList,
  idValidateInfo,
  memberLevelMap,
  orderCustomerInfoLoading,
  updateBookerLoading,
  addMemberLoading,
  updateMemberLoading,
  saveDataFn,
  orderAddMemberFn,
  orderUpdateMemberFn,
  orderUpdateBookerFn,
  orderMemberCheckOutFn,
  getOrderDetailBaseInfoFn,
  getOrderCustomerInfoFn,
  updateIdValidatedResFn,
  getBusinessPaymentTypeFn,
  // queryIsChangeMasterFn,
}) => {
  const { resvNo } = useParams<HistoryParams>();
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [showCertLoading, setShowCertLoading] = useState<boolean>(false);
  const [isReadCertSuccess, setIsReadCertSuccess] = useState<boolean>(false);

  const [checkinStatus, setCheckinStatus] = useState(0);

  const [selectedRecNo, setSelectedRecNo] = useState();
  const [selectedItem, setSelectedItem] = useState<IroomInfo>();

  const [cardInfo, setCardInfo] = useState<Partial<CardInfo>>();

  const [checkMobileConflictLoading, setCheckMobileConflictLoading] = useState<boolean>(false);
  const [checkSamePersonLoading, setCheckSamePersonLoading] = useState<boolean>(false);

  const additionalRecordMobileRef = useRef<IadditionalRecordMobileRef>();
  const cardInfoRef = useRef<ImodalRef>();
  const cardPurchaseRef = useRef<IcardPurchaseRef>();
  const cardRechargeRef = useRef<IcardRechargeRef>();
  const phoneCheckModalRef = useRef<PhoneCheckModalRef>();
  const guestDetailRef = useRef<IGuestDetailRef>();
  const modalRef = useRef<ImodalFormRef>();
  const checkInModalRef = useRef<ImodalFormRef>();
  const intlCtx = useContext(IntlContext);

  const reserveFormAttr: Array<IFieldItem> = useMemo(() => {
    return [
      {
        label: renderIntlLabel('order_roomorder_name'),
        key: 'name',
        rules: [
          {
            required: true,
            message: renderIntlLabel('order_roomorder_query_validator_please_input_charactor', {
              num: 100,
            }),
            max: 100,
          },
        ],
      },
      {
        label: renderIntlLabel('order_roomorder_mobile'),
        key: 'mobile',
        type: 'group',
        component: <BaseMobileInput isKeyPerson={false} />,
        rules: [
          ({ getFieldValue }) => ({
            validator: (_, v) => {
              const { areaCode, mobileStr } = parseAreaMobileStr(v);
              const val = getFieldValue('otaOrderNo');
              const email = getFieldValue('email');
              if ((areaCode && mobileStr) || val || email) {
                // 是否修改过，修改过校验是否脱敏
                // v2.11 校验格式
                if (areaCode && mobileStr && v !== reserveDetail?.mobile) {
                  if (v.includes('*') || !validateMobileValue(v)) {
                    return Promise.reject(
                      new Error(
                        renderIntlLabel(
                          'order_frontDesk_validate_please_check_mobile_error_format',
                        ),
                      ),
                    );
                  }
                }
                return Promise.resolve('');
              }
              return Promise.reject(
                new Error(renderIntlLabel('order_detail_placeholder_input_mobile_virtual_number')),
              );
            },
          }),
        ],
      },
      {
        label: renderIntlLabel('order_detail_virtual_number'),
        key: 'otaOrderNo',
        rules: [
          { message: renderIntlLabel('order_detail_placeholder_input_OTA_virtual_number') },
          ({ getFieldValue }) => ({
            validator: (_, v) => {
              const val = getFieldValue('mobile');
              const { areaCode, mobileStr } = parseAreaMobileStr(val);
              const email = getFieldValue('email');
              if (v || (areaCode && mobileStr) || email) {
                return Promise.resolve('');
              }
              return Promise.reject(
                new Error(renderIntlLabel('order_detail_placeholder_input_mobile_virtual_number')),
              );
            },
          }),
        ],
      },
      {
        label: renderIntlLabel('manage_shop_profile_tory_column_email'),
        key: 'email',
        type: 'group',
        component: <BaseEmailInput isKeyPerson={false} />,
        rules: [
          ({ getFieldValue }) => ({
            validator: (_, v) => {
              const val = getFieldValue('mobile');
              const { areaCode, mobileStr } = parseAreaMobileStr(val);
              const otaNo = getFieldValue('otaOrderNo');
              if (v || (areaCode && mobileStr) || otaNo) {
                // 是否修改过，修改过校验邮箱格式是否正确
                if (v && v !== reserveDetail?.email && !EMAIL_REG.test(v)) {
                  return Promise.reject(
                    new Error(
                      renderIntlLabel('order_frontDesk_validate_please_check_email_error_format'),
                    ),
                  );
                }
                return Promise.resolve('');
              }
              return Promise.reject(
                new Error(renderIntlLabel('order_detail_placeholder_input_mobile_virtual_number')),
              );
            },
          }),
        ],
      },
    ];
  }, [reserveDetail]);
  // 是否有房主
  const isExistHouseOwner = useMemo(() => {
    return (
      orderBaseInfo &&
      orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder &&
      Array.isArray(checkInCustomerList) &&
      checkInCustomerList.length &&
      checkInCustomerList?.some((item) => item.memberType === MemberType.HouseOwner)
    );
  }, [orderBaseInfo, checkInCustomerList]);

  const initGuestData = () => {
    getOrderDetailBaseInfoFn({ resvNo });
    getBusinessPaymentTypeFn();
    getOrderCustomerInfoFn({ resvNo });
    // 能否换房主，有没有产生自动房费
    // queryIsChangeMasterFn({ resvNo });
  };

  const handleOpenReserveModal = (isEdit, record?: IcustomerInfo) => {
    modalRef.current?.openModal();
    setIsEditing(isEdit);
    saveDataFn({
      reserveDetail: {
        ...record,
        // showMobile明文，mobile秘文，没落中台展现明文
        mobile: record?.showMobile || record?.mobile,
        email: record?.showEmail || record?.email,
      },
    });
  };

  const getMobileByCertNo = async (params, _isEdit?: boolean) => {
    const { name, certType, certNo, wyuid, leaveFlag } = params;
    if (!name || !certType || !certNo || leaveFlag) {
      return;
    }
    try {
      const result = { ...params };
      // 带出明文手机号、邮箱(通过明文、兼容加密证件号)
      const res = await fetchCustomerInfo({ name, certType, certNo });
      const { wyuid: currentWyuid, certType: type, mobile, email, remark } = res?.data || {};
      result.wyuid = currentWyuid;
      if (type) {
        result.certType = type;
      }
      if (mobile) {
        result.mobile = mobile;
      }
      if (email) {
        result.email = email;
      }
      if (remark) {
        result.remark = remark;
      }
      saveDataFn({
        checkInDetail: result,
      });
      updateIdValidatedResFn({ idValidateInfo: {} });
    } catch (error) {
      // 编辑有脱敏时不校验提示
      if (!_isEdit || !certNo?.includes('*')) {
        updateIdValidatedResFn({ idValidateInfo: error });
      }
    }
  };

  const closeSocket = () => {
    if (cardInstance && cardInstance.socket) {
      cardInstance.socket.close();
      cardInstance = null;
    }
  };
  const fnReadIdCard = (detail) => {
    // detail 缓存房号
    if (cardInstance) {
      cardInstance
        .readIdCard(false)
        .then(async (res) => {
          const { name, id } = res;
          saveDataFn({
            checkInDetail: { ...detail, name, certType: CertIDType.ID_CARD, certNo: id },
          });
          getMobileByCertNo({ ...detail, name, certType: CertIDType.ID_CARD, certNo: id });

          setShowCertLoading(false);
          setIsReadCertSuccess(true);
          // 缓存信息
          setCardInfo(res);
          closeSocket();
          trackIDCardReader({ type: IDCardReaderScene.OrderDetailAddGuest });
        })
        .catch(() => {
          fnReadIdCard(detail);
        });
    }
  };

  const handleRadioChange = (e) => {
    setCheckinStatus(e.target.value);
  };

  const handleOpenCheckInModal = async (isEdit: boolean, record?: Partial<IcustomerInfo>) => {
    setIsEditing(isEdit);
    checkInModalRef.current?.openModal();
    if (isEdit) {
      saveDataFn({ checkInDetail: { ...record } });
      updateIdValidatedResFn({ idValidateInfo: {} });
    } else {
      // 选择入住中，新增宾客时自动带上房间
      const isCheckin = checkInRoomInfoList?.some(
        (item) => item.roomId === selectedItem?.roomId && item.status === SubOrderStatus.CheckIn,
      );
      saveDataFn({
        checkInDetail: {
          roomId: isCheckin ? selectedItem?.roomId : '',
          // 商户默认证件类型
          certType: TenantGlobalConfig.getSystemConfig().defaultCertType,
        },
      });

      // 新增
      setShowCertLoading(true);
      cardInstance = new Card();
      cardInstance.socket.addEventListener('open', () => {
        fnReadIdCard({ roomId: selectedItem?.roomId });
      });
      cardInstance.socket.addEventListener('error', () => {
        // message.error('读取身份证失败，请重试');
        setCardInfo({});
        closeSocket();
      });
    }
  };
  const handleBuyMemberCard = (record?: Partial<IcustomerInfo>) => {
    const { name, certType, certNo, mobile, wyuid, email } = record || {};
    cardPurchaseRef.current.openDrawer({
      isNew: false,
      name,
      certType,
      certNo,
      mobile,
      wyuid,
      email,
    });
  };
  const handleRechargeMemberCard = (record: Partial<IcustomerInfo>) => {
    const { wyuid, accountType, name, certType, certNo, mobile, email } = record;
    cardRechargeRef.current.openDrawer({
      isNew: false,
      wyuid,
      accountType,
      name,
      certType,
      certNo,
      mobile,
      email,
    });
  };
  // 打开宾客详细抽屉
  const handleOpenGuestDetail = (record) => {
    guestDetailRef.current.openDrawer({ guestRecord: record });
  };

  const handleClosePurchaseDrawer = ({ isBuySuccess }) => {
    if (isBuySuccess) {
      initGuestData();
    }
  };
  const handleCloseRechargeDrawer = (val) => {
    if (val) {
      initGuestData();
    }
  };

  const handleCloseGuestDetailDrawer = () => {
    getBusinessPaymentTypeFn();
    getOrderCustomerInfoFn({ resvNo });
  };

  const handleLeaveHotel = (id: number) => {
    orderMemberCheckOutFn({ resvNo, id });
  };
  const handleOpenSetHouseOwnerModal = (record) => {
    Modal.confirm({
      title: renderIntlLabel('order_action_change_house_owner'),
      content: (
        <>
          <div>
            <div>{renderIntlLabel('order_detail_change_house_owner1')}：</div>
            <div>{renderIntlLabel('order_detail_change_house_owner11')}</div>
            <div>{renderIntlLabel('order_detail_change_house_owner12')}</div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <div>{renderIntlLabel('order_detail_change_house_owner2')}：</div>
            <div>{renderIntlLabel('order_detail_change_house_owner21')}</div>
            <div>{renderIntlLabel('order_detail_change_house_owner22')}</div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <div>{renderIntlLabel('order_detail_change_house_owner3')}：</div>
            <div>{renderIntlLabel('order_detail_change_house_owner31')}</div>
            <div>{renderIntlLabel('order_detail_change_house_owner32')}</div>
          </div>
        </>
      ),
      onOk: async () => {
        // 原房主信息
        const originItem =
          (checkInCustomerList || []).find((item) => item.memberType === MemberType.HouseOwner) ||
          {};

        // 不存在常用联系方式
        const defaultType = TenantGlobalConfig.getSystemConfig().contractType;
        if (
          (defaultType === ContractType.MOBILE && !record?.mobile) ||
          (defaultType === ContractType.EMAIL && !record?.email)
        ) {
          additionalRecordMobileRef.current.openModal({
            record,
            callback: async (values) => {
              const { id } = record;
              const newMatserRes = await fetchSaveNewMasterMobile({ id, ...values });
              if (newMatserRes?.code === 0) {
                additionalRecordMobileRef.current.closeModal();
                // 设为房主
                if (record?.id) {
                  const res = await fetchBecomeMasterV2({
                    newMasterId: record.id,
                    masterId: originItem.id,
                  });
                  if (res?.code === 0) {
                    initGuestData();
                  }
                }
              }
            },
          });
        } else {
          // 设为房主
          if (record?.id) {
            const res = await fetchBecomeMasterV2({
              newMasterId: record.id,
              masterId: originItem.id,
            });
            if (res?.code === 0) {
              initGuestData();
            }
          }
        }
      },
    });
  };

  const onSelected = (recNo, item) => {
    setSelectedRecNo(recNo);
    setSelectedItem(item);
  };

  const onReserveOkDebounce = debounce((values) => {
    if (isEditing) {
      // 修改
      orderUpdateBookerFn({ resvNo, ...values }).then(() => {
        modalRef.current.closeModal();
      });
    }
  }, 1000);

  const submitCheckInDetail = async (values) => {
    const checkInList = checkInRoomInfoList?.filter(
      (item) => item.roomId === values?.roomId && item.status === SubOrderStatus.CheckIn,
    );
    const { roomNo, recNo } = get(checkInList, '[0]') || {};
    if (!isEditing) {
      // 新增
      const params = {
        resvNo,
        recNo,
        roomNo,
        ...filterFormParams(transformCardInfo(cardInfo)),
        ...values,
        name: (values?.name || '').trim(),
        certNo: (values?.certNo || '').trim(),
        // 1读卡器，2手动输入
        idCardReadStatus: isReadCertSuccess ? 1 : 2,
      };
      orderAddMemberFn(params).then(() => {
        checkInModalRef.current.closeModal();
        showGamePromptModal([{ wyuId: checkInDetail.wyuid }]);
      });
    } else {
      // 修改
      orderUpdateMemberFn({
        resvNo,
        id: checkInDetail.id,
        roomNo,
        ...values,
        name: (values?.name || '').trim(),
        certNo: (values?.certNo || '').trim(),
      }).then(() => {
        checkInModalRef.current.closeModal();
      });
    }
  };

  const checkSameCheckinDifferentRoom = (values) => {
    return new Promise((resolve) => {
      const { roomId, memberType } = values || {};
      const { wyuid } = checkInDetail;
      if (wyuid && (memberType === MemberType.CheckIn || memberType === MemberType.HouseOwner)) {
        setCheckSamePersonLoading(true);
        fetchCurrentCheckinStatus({ wyuids: [wyuid] })
          .then((res) => {
            if (res?.code === 0 && Array.isArray(res?.data) && res?.data?.length) {
              const { commonCode: currentCommonCode } = currentShop || {};
              const { roomNo: currentRoomNo } =
                checkInRoomInfoList?.find((item) => item.roomId === roomId) || {};
              const samePersonDifferentRoom = res?.data.find(
                (item) => currentCommonCode !== item.commonCode || currentRoomNo !== item.roomNo,
              );
              // 入住人冲突，门店或者房号不一样
              if (samePersonDifferentRoom && Object.keys(samePersonDifferentRoom)?.length) {
                const { name, certNo: certNoTarget, roomNo, commonCode, commonName } =
                  samePersonDifferentRoom || {};
                Modal.warning({
                  title: renderIntlLabel('order_detail_checkin_conflict'),
                  content: (
                    <>
                      <Row>
                        <Col span={24} style={{ marginBottom: '16px' }}>
                          {renderIntlLabel('order_detail_checkin_conflict_description', {
                            name,
                            certNoTarget,
                          })}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={4} style={{ fontWeight: 'bold' }}>
                          {renderIntlLabel('order_store')}
                        </Col>
                        <Col>
                          {commonCode}
                          {commonName}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={4} style={{ fontWeight: 'bold' }}>
                          {renderIntlLabel('order_roomorder_room_number')}
                        </Col>
                        <Col>{roomNo}</Col>
                      </Row>
                    </>
                  ),
                  okText: renderIntlLabel('order_action_close'),
                });
                resolve(true);
                return;
              }
            }
            resolve(false);
          })
          .finally(() => {
            setCheckSamePersonLoading(false);
          });
      } else {
        // 不是入住人、房主
        resolve(false);
      }
    });
  };

  const submitCheckValues = async (values) => {
    // 身份证号错误
    if (idValidateInfo?.code === 101920012 || idValidateInfo?.code === 102020011) {
      message.error(idValidateInfo?.msg);
      return;
    }

    // 入住人冲突
    const isConflict = await checkSameCheckinDifferentRoom(values);
    if (isConflict) {
      return;
    }

    const { wyuid } = checkInDetail;
    const { name, mobile, email } = values;
    if (wyuid && (mobile || email)) {
      setCheckMobileConflictLoading(true);
      phoneCheckModalRef.current
        .showPhoneCheck([{ wyuid, name, mobile, email }])
        .then((res) => {
          if (res.success) {
            submitCheckInDetail(values);
          }
        })
        .finally(() => {
          setCheckMobileConflictLoading(false);
        });
    } else {
      // 可能获取网鱼uid接口挂掉或者根本没有网鱼uid
      submitCheckInDetail(values);
    }
  };

  const onCheckInOkDebounce = debounce(() => {
    checkInModalRef.current?.validateFields().then(async (values: IcustomerInfo) => {
      if (intlCtx.TenantSysConfig.nationValidate && cardInfo?.address?.includes('新疆')) {
        Modal.warning({
          title: renderIntlLabel('order_detail_containe_xinjiang_title'),
          content: (
            <>
              <div>{renderIntlLabel('order_detail_containe_xinjiang_description')}</div>
            </>
          ),
          okText: renderIntlLabel('order_action_confirm_queding'),
          onOk: () => {
            submitCheckValues(values);
          },
        });
      } else {
        submitCheckValues(values);
      }
    });
  }, 1000);

  const handleShowCardDetail = () => {
    cardInfoRef.current.openModal();
  };

  const handleCloseReserveModal = () => {
    setIsEditing(false);
    saveDataFn({ reserveDetail: {} });
  };

  const handleCloseCheckinModal = () => {
    checkInModalRef.current?.closeModal();
    setIsEditing(false);
    saveDataFn({ checkInDetail: {} });

    setShowCertLoading(false);
    setIsReadCertSuccess(false);
    setCardInfo({});
    closeSocket();
  };

  const onValuesChangeDebounce = useCallback((changedValues) => {
    // 读取或输入证件号，loading消失
    if (changedValues.certType || changedValues.certNo) {
      setShowCertLoading(false);
      setIsReadCertSuccess(false);
      setCardInfo({});
      closeSocket();
    }
  }, []);

  const handleBlur = () => {
    const values = checkInModalRef.current?.getFieldsValue();
    getMobileByCertNo({ ...checkInDetail, ...values }, isEditing);
  };

  useEffect(() => {
    return () => {
      setCheckinStatus(0);
      setShowCertLoading(false);
      setIsReadCertSuccess(false);
      setCardInfo({});
      closeSocket();
    };
  }, []);

  const roomDataSource = useMemo(() => {
    return checkInRoomInfoList
      ?.filter((item) => item.status === SubOrderStatus.CheckIn)
      ?.map((item) => ({
        label: item.roomNo,
        value: item.roomId,
      }));
  }, [checkInRoomInfoList]);

  const checkInFormAttr: Array<IFieldItem> = useMemo(() => {
    let checkinFormItem: Array<IFieldItem> = [
      {
        label: renderIntlLabel('order_detail_checkin_identity'),
        key: 'memberType',
        type: 'radioButton',
        rules: [
          {
            required: true,
            message: renderIntlLabel('order_detail_placeholder_please_select_checkin_identity'),
          },
        ],
        dataSource: [
          { label: renderIntlLabel('order_roomorder_checkin_person'), value: 1 },
          { label: renderIntlLabel('order_roomorder_visitor'), value: 2 },
        ],
      },
      {
        label: renderIntlLabel('order_detail_checkin_room'),
        key: 'roomId',
        type: 'select',
        rules: [
          {
            required: true,
            message: renderIntlLabel('order_detail_placeholder_please_select_checkin_room'),
          },
        ],
        dataSource: roomDataSource,
      },
    ];
    const { leaveFlag, memberType } = checkInDetail || {};
    // 编辑时,未离店房主
    if (isEditing && !leaveFlag && memberType === MemberType.HouseOwner) {
      checkinFormItem = [
        {
          label: renderIntlLabel('order_detail_checkin_room'),
          key: 'roomId',
          type: 'select',
          rules: [
            {
              required: true,
              message: renderIntlLabel('order_detail_placeholder_please_select_checkin_room'),
            },
          ],
          dataSource: roomDataSource,
        },
      ];
    }
    // 编辑时,已离店
    if (isEditing && leaveFlag) {
      checkinFormItem = [];
    }

    return checkinFormItem.concat([
      {
        label: renderIntlLabel('order_roomorder_name'),
        key: 'name',
        rules: [
          {
            required: !leaveFlag,
            message: renderIntlLabel('order_roomorder_query_validator_please_input_charactor', {
              num: 100,
            }),
            max: 100,
          },
        ],
        editable: !leaveFlag && !isReadCertSuccess,
        componentProps: {
          onBlur: handleBlur,
        },
      },
      {
        label: renderIntlLabel('order_roomorder_cert_type'),
        key: 'certType',
        type: 'select',
        rules: [
          {
            required: !isEditing,
            message: renderIntlLabel('order_frontDesk_validate_select_cert_type'),
          },
        ],
        dataSource: TenantGlobalConfig.getSystemConfig().certTypesDataSource,
        editable: !isEditing && !isReadCertSuccess,
        componentProps: {
          onBlur: handleBlur,
        },
      },
      {
        label: renderIntlLabel('order_roomorder_cert_no'),
        key: 'certNo',
        rules: [
          {
            required: !isEditing,
          },
        ],
        editable: !isEditing && !isReadCertSuccess,
        componentProps: {
          onBlur: handleBlur,
        },
      },
      {
        label: renderIntlLabel('order_roomorder_mobile'),
        key: 'mobile',
        type: 'group',
        component: (
          <BaseMobileInput
            isKeyPerson={memberType === MemberType.HouseOwner}
            selectProps={{ disabled: leaveFlag }}
            inputProps={{ disabled: leaveFlag }}
          />
        ),
        rules: [
          {
            validator(_, val) {
              if (leaveFlag) {
                return Promise.resolve();
              }
              const { areaCode, mobileStr } = parseAreaMobileStr(val);
              // 只填一个
              if ((areaCode && !mobileStr) || (!areaCode && mobileStr)) {
                return Promise.reject(
                  new Error(
                    renderIntlLabel('order_frontDesk_validate_please_check_mobile_error_format'),
                  ),
                );
              }
              // 是否修改过，修改过校验是否脱敏
              if (val && val !== checkInDetail?.mobile && val.includes('*')) {
                return Promise.reject(
                  new Error(
                    renderIntlLabel('order_frontDesk_validate_please_check_mobile_error_format'),
                  ),
                );
              }
              // 关键人常用联系方式手机号是否必填
              if (
                memberType === MemberType.HouseOwner &&
                intlCtx.TenantSysConfig.contractType === ContractType.MOBILE &&
                !val
              ) {
                return Promise.reject(
                  new Error(
                    renderIntlLabel('order_frontDesk_validate_please_check_mobile_error_format'),
                  ),
                );
              }

              return Promise.resolve();
            },
          },
        ],
      },
      {
        label: renderIntlLabel('help_store_address_type_email'),
        key: 'email',
        type: 'group',
        component: (
          <BaseEmailInput isKeyPerson={memberType === MemberType.HouseOwner} disabled={leaveFlag} />
        ),
        rules: [
          {
            validator(_, val) {
              if (leaveFlag) {
                return Promise.resolve();
              }
              // 是否修改过，修改过校验邮箱格式是否正确
              if (val && val !== checkInDetail?.email && !EMAIL_REG.test(val)) {
                return Promise.reject(
                  new Error(
                    renderIntlLabel('order_frontDesk_validate_please_check_email_error_format'),
                  ),
                );
              }
              if (
                memberType === MemberType.HouseOwner &&
                intlCtx.TenantSysConfig.contractType === ContractType.EMAIL &&
                !val
              ) {
                return Promise.reject(
                  new Error(
                    renderIntlLabel('order_frontDesk_validate_please_check_email_error_format'),
                  ),
                );
              }
              return Promise.resolve();
            },
          },
        ],
      },
      {
        label: renderIntlLabel('order_detail_guest_remark'),
        key: 'remark',
        type: 'textArea',
        componentProps: {
          showCount: true,
          maxLength: 10000,
        },
      },
    ]);
  }, [roomDataSource, isEditing, isReadCertSuccess, checkInDetail]);

  const reserveColumns = useMemo(() => {
    const commonColumns: Array<ColumnProps<IcustomerInfo>> = [
      {
        title: renderIntlLabel('order_roomorder_guest'),
        dataIndex: 'name',
        render: (val) => (
          <>
            <Tag>{renderIntlLabel('order_roomorder_subscriber')}</Tag>
            {val}
          </>
        ),
      },
      {
        title: renderIntlLabel('order_roomorder_cert_type'),
        dataIndex: 'certType',
        render: (val) => TenantGlobalConfig.getSystemConfig().certTypesMap?.[val],
      },
      {
        title: renderIntlLabel('order_roomorder_cert_no'),
        dataIndex: 'certNo',
      },
      {
        title: renderIntlLabel('order_roomorder_mobile'),
        render: (val) => formatAreaMobileStr(val.showMobile || val.mobile),
      },
      {
        title: renderIntlLabel('order_detail_virtual_number'),
        dataIndex: 'otaOrderNo',
      },
      {
        title: renderIntlLabel('help_store_address_type_email'),
        dataIndex: 'email',
        render: (_, record) => record.showEmail || record.email,
      },
      {
        title: renderIntlLabel('order_roomorder_member_level'),
        dataIndex: 'memberLevel',
        render: (val, record) => {
          if (!record.certNo && !record.mobile) {
            return '-';
          }
          return memberLevelMap[val]?.name;
        },
      },
    ];
    // 直连渠道时不可编辑
    // 预订取消订单、退房订单、空订单，不可编辑
    const editable =
      sourceChannelType !== PriceChannel.CRS &&
      sourceChannelType !== PriceChannel.MT_ZL &&
      sourceChannelType !== PriceChannel.XC_ZL &&
      orderBaseInfo.resvStatus !== MainOrderStatus.CancelReservationOrder &&
      orderBaseInfo.resvStatus !== MainOrderStatus.CheckoutOrder &&
      (!Array.isArray(checkInRoomInfoList) || checkInRoomInfoList.length === 0);
    commonColumns.push({
      title: renderIntlLabel('order_action'),
      render: (_, record) => (
        <>
          {editable ? (
            <MemberCancelCheckButton
              type="link"
              wyuid={
                // fix #2025-01-16 吴玉林提出只要主订单的订单状态是预订或取消预订订单 就不走会员注销校验逻辑
                orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                  ? null
                  : record?.wyuid
              }
              businessDate={
                // 2025-01-07 张涵提出只要主订单的订单状态是入住订单 就不传时间
                orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                  ? null
                  : orderBaseInfo?.createTime
              }
              text={renderIntlLabel('order_action_edit')}
              onClick={() => handleOpenReserveModal(true, record)}
            />
          ) : null}
          {record?.wyuid ? (
            <MemberCancelCheckButton
              type="link"
              wyuid={
                orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                  ? null
                  : record?.wyuid
              }
              businessDate={
                orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                  ? null
                  : orderBaseInfo?.createTime
              }
              text={renderIntlLabel('order_action_guest_detail')}
              onClick={() => handleOpenGuestDetail(record)}
            />
          ) : null}
        </>
      ),
      fixed: 'right',
      align: 'right',
    });
    return commonColumns;
  }, [sourceChannelType, orderBaseInfo, checkInRoomInfoList]);

  const checkInColumns: ColumnsType<IcustomerInfo> = [
    {
      title: renderIntlLabel('order_roomorder_room_number'),
      dataIndex: 'roomNo',
    },
    {
      title: renderIntlLabel('order_roomorder_guest'),
      dataIndex: 'name',
      render: (val, record) => (
        <>
          <Tag>
            {record.leaveFlag
              ? renderIntlLabel('order_detail_has_leave_store')
              : MEMBER_TYPE_MAP[record.memberType]}
          </Tag>
          <span>{val}</span>
        </>
      ),
    },
    {
      title: renderIntlLabel('order_roomorder_cert_type'),
      dataIndex: 'certType',
      render: (val) => TenantGlobalConfig.getSystemConfig().certTypesMap?.[val],
    },
    {
      title: renderIntlLabel('order_roomorder_cert_no'),
      dataIndex: 'certNo',
    },
    {
      title: renderIntlLabel('order_roomorder_mobile'),
      dataIndex: 'mobile',
      render: (val) => formatAreaMobileStr(val),
    },
    {
      title: renderIntlLabel('help_store_address_type_email'),
      dataIndex: 'email',
    },
    {
      title: renderIntlLabel('order_roomorder_member_level'),
      dataIndex: 'memberLevel',
      render: (val) => memberLevelMap[val]?.name,
    },
    {
      title: renderIntlLabel('order_detail_remainingBalance'),
      dataIndex: 'remainingBalance',
      render: (val) => parseFen2Currency(val || 0),
      align: 'right',
    },
    {
      title: renderIntlLabel('order_detail_guest_remark'),
      dataIndex: 'remark',
    },
    {
      title: renderIntlLabel('order_action'),
      render: (_, record) => {
        return (
          <>
            {!record.leaveFlag && record.memberType !== MemberType.HouseOwner ? (
              <>
                <Popconfirm
                  title={renderIntlLabel('order_detail_msg_confirm_is_leave')}
                  onConfirm={() => handleLeaveHotel(record.id)}
                >
                  <Button type="link">{renderIntlLabel('order_detail_leave_store')}</Button>
                </Popconfirm>
                <Divider type="vertical" />
                {
                  // 是入住人且没有产生自动房费
                  record.memberType === MemberType.CheckIn ? (
                    <>
                      <Button type="link" onClick={() => handleOpenSetHouseOwnerModal(record)}>
                        {renderIntlLabel('order_action_set_house_owner')}
                      </Button>
                      <Divider type="vertical" />
                    </>
                  ) : null
                }
              </>
            ) : null}

            {record.canBuyCard ? (
              <>
                <MemberCancelCheckButton
                  type="link"
                  wyuid={
                    orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                    orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                      ? null
                      : record?.wyuid
                  }
                  businessDate={
                    orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                      ? null
                      : orderBaseInfo?.createTime
                  }
                  text={renderIntlLabel('order_action_buy_member_card')}
                  onClick={() => handleBuyMemberCard(record)}
                />
                <Divider type="vertical" />
              </>
            ) : null}

            {businessList?.some(
              (item) => item.businessCode === 'MEMBER_STORED_VALUE' && item.status === 0,
            ) ? (
              <>
                <MemberCancelCheckButton
                  type="link"
                  wyuid={
                    orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                    orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                      ? null
                      : record?.wyuid
                  }
                  businessDate={
                    orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                      ? null
                      : orderBaseInfo?.createTime
                  }
                  text={renderIntlLabel('order_action_recharge')}
                  onClick={() => handleRechargeMemberCard(record)}
                />
                <Divider type="vertical" />
              </>
            ) : null}
            <MemberCancelCheckButton
              type="link"
              wyuid={
                orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                  ? null
                  : record?.wyuid
              }
              businessDate={
                orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                  ? null
                  : orderBaseInfo?.createTime
              }
              text={renderIntlLabel('order_action_edit')}
              onClick={() => handleOpenCheckInModal(true, record)}
            />
            <Divider type="vertical" />
            <MemberCancelCheckButton
              type="link"
              wyuid={
                orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
                orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder
                  ? null
                  : record?.wyuid
              }
              businessDate={
                orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder
                  ? null
                  : orderBaseInfo?.createTime
              }
              text={renderIntlLabel('order_action_guest_detail')}
              onClick={() => handleOpenGuestDetail(record)}
            />
          </>
        );
      },
      fixed: 'right',
      align: 'right',
    },
  ];

  const filterGuestersByLeaveFlag = (list, status) => {
    // 全部在住、离店
    if (status === 0) {
      return list;
    }
    const isLeave = status === 2;
    return list?.filter((item) => item.leaveFlag === isLeave);
  };

  const [columns, dataSource] = useMemo((): [IcustomColumnType<any>[], []] => {
    if (!selectedRecNo) {
      // 全部
      return [checkInColumns, filterGuestersByLeaveFlag(checkInCustomerList, checkinStatus)];
    }
    if (selectedRecNo === 'reservePeople') {
      // 预订人
      return [reserveColumns, reserveCustomerList];
    }
    return [
      checkInColumns,
      filterGuestersByLeaveFlag(
        checkInCustomerList.filter((item) => selectedItem?.recNo === item.recNo),
        checkinStatus,
      ),
    ];
  }, [
    checkinStatus,
    selectedRecNo,
    selectedItem,
    reserveColumns,
    checkInColumns,
    reserveCustomerList,
    checkInCustomerList,
  ]);

  const title = useMemo(() => {
    if (!isEditing) {
      return renderIntlLabel('order_detail_add_checkin_visitor');
    }
    if (checkInDetail?.memberType === MemberType.HouseOwner) {
      return renderIntlLabel('order_detail_edit_house_owner');
    }
    return renderIntlLabel('order_detail_edit_guest');
  }, [isEditing, checkInDetail]);

  return (
    <>
      <div className={style.container}>
        <CardInfoModal ref={cardInfoRef} cardInfo={cardInfo} />
        <CardPurchase ref={cardPurchaseRef} onCloseDrawer={handleClosePurchaseDrawer} />
        <CardRecharge ref={cardRechargeRef} onCloseDrawer={handleCloseRechargeDrawer} />
        {/* 补录手机号 */}
        <AdditionalRecordMobile
          ref={additionalRecordMobileRef}
          submitLoading={updateMemberLoading}
        />
        <PhoneCheckModal innerRef={phoneCheckModalRef} />
        <GuestDetailDrawer ref={guestDetailRef} onClose={handleCloseGuestDetailDrawer} />

        <div className="groupLabel">{renderIntlLabel('order_detail_guest_info')}</div>
        <div className="space-between" style={{ alignItems: 'flex-start', marginTop: 16 }}>
          <Form.Item
            label={renderIntlLabel('order_detail_checkin_status')}
            style={{ marginBottom: 0 }}
          >
            <Radio.Group value={checkinStatus} onChange={handleRadioChange}>
              <Radio.Button value={0}>{renderIntlLabel('order_option_label_all')}</Radio.Button>
              <Radio.Button value={1}>
                {renderIntlLabel('order_detail_option_live_in')}
              </Radio.Button>
              <Radio.Button value={2}>
                {renderIntlLabel('order_detail_option_leave_store')}
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Button
            type="primary"
            disabled={!isExistHouseOwner}
            onClick={() => handleOpenCheckInModal(false, {})}
          >
            {renderIntlLabel('order_detail_add_checkin_visitor')}
          </Button>
        </div>

        <div className={style.guestContent}>
          <Skeleton loading={orderCustomerInfoLoading}>
            <RoomTypeScroll
              extraList={reserveCustomerList}
              checkInCustomerList={checkInCustomerList}
              list={checkInRoomInfoList}
              onSelected={onSelected}
            />
          </Skeleton>
          {/*  右侧 */}
          <div>
            <Skeleton loading={orderCustomerInfoLoading}>
              <FixStickyTable>
                <EditCellTable
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  scroll={{ x: 'max-content' }}
                  sticky
                />
              </FixStickyTable>
            </Skeleton>
          </div>
        </div>
        {/* 预订人 */}
        <ModalForm
          width={700}
          title={`${
            !isEditing ? renderIntlLabel('order_add') : renderIntlLabel('order_edit')
          }${renderIntlLabel('order_roomorder_subscriber')}`}
          ref={modalRef}
          formAttr={reserveFormAttr}
          value={reserveDetail}
          confirmLoading={updateBookerLoading}
          onOk={onReserveOkDebounce}
          onCancel={handleCloseReserveModal}
        />
        {/* 入住人或访客 */}
        <ModalForm
          wrapClassName={style.modalForm}
          width={700}
          title={title}
          ref={checkInModalRef}
          formAttr={checkInFormAttr}
          value={checkInDetail}
          confirmLoading={addMemberLoading || updateMemberLoading}
          onValuesChange={onValuesChangeDebounce}
          onCancel={handleCloseCheckinModal}
          footer={
            <>
              <Button type="ghost" onClick={handleCloseCheckinModal}>
                {renderIntlLabel('order_frontDesk_action_btn_cancel')}
              </Button>
              {!isEditing && !showCertLoading && isReadCertSuccess ? (
                <Button type="ghost" onClick={handleShowCardDetail}>
                  {renderIntlLabel('order_action_detailed_information')}
                </Button>
              ) : null}
              <Button
                type="primary"
                onClick={onCheckInOkDebounce}
                loading={
                  addMemberLoading ||
                  updateMemberLoading ||
                  checkMobileConflictLoading ||
                  checkSamePersonLoading
                }
              >
                {renderIntlLabel('order_action_confirm_queding')}
              </Button>
            </>
          }
        >
          {!isEditing && showCertLoading ? (
            <Alert message={renderIntlLabel('order_cert_no_being_read')} type="info" showIcon />
          ) : null}
          {!isEditing && !showCertLoading && isReadCertSuccess ? (
            <Alert message={renderIntlLabel('order_cert_no_has_read')} type="success" showIcon />
          ) : null}
        </ModalForm>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { currentShop } = state.user;
  return {
    currentShop,
    ...state.order,
    ...state.guest,
  };
};

export default connect(mapStateToProps, {
  clearDataFn: clearData,
  saveDataFn: saveData,
  orderAddMemberFn: orderAddMember,
  orderUpdateMemberFn: orderUpdateMember,
  orderUpdateBookerFn: orderUpdateBooker,
  orderMemberCheckOutFn: orderMemberCheckOut,
  getOrderDetailBaseInfoFn: getOrderDetailBaseInfo,
  getOrderCustomerInfoFn: getOrderCustomerInfo,
  updateIdValidatedResFn: updateIdValidatedRes,
  getBusinessPaymentTypeFn: getBusinessPaymentType,
  queryIsChangeMasterFn: queryIsChangeMaster,
})(React.memo(Guest));
